import { shopsContact, getShopKey } from '@providers/ConfigProvider';

const getAppName = (shopId: string): string => shopsContact[getShopKey(shopId)]?.appName?.toLowerCase();

export default getAppName;
